<script setup lang="ts">
import {PropType} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const props = defineProps({
  params: {
    type: Object as PropType<ICellRendererParams>,
    required: true
  }
});
const fieldValue = props.params.value;

</script>

<template>
  <q-item v-if="fieldValue" dense class="tw-px-0 tw-w-full tw-h-full">
    <q-item-section>
      <div class="tw-w-full tw-flex tw-justify-between">
        <div class="tw-overflow-hidden" v-text="fieldValue"/>
        <div class="tw-flex tw-items-center">
          <NamaIcon :default-icon="fieldValue"/>
        </div>
      </div>
    </q-item-section>
  </q-item>
</template>
